module.exports = __webpack_public_path__ + "static/media/img2-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img2-4.png
// module id = 1704
// module chunks = 3